<template lang="pug">
  nav.product-filters-menu.select-none.text-18.md-text-17

    //- (1. GLOBAL LINKS mobile only)
    .md-hidden.px-10(v-if="!winIs('md')", ref="primary")
      h5.text-18.text-center.mb-36 Browse
      //- (categories, mobile)
      dropdown
        h6(slot="title") Shop
        ul.mt-18.-pb-18
          li.border-t.pl-30(v-for="cat in categories")
            router-link.block.pl-30.py-18.hover-text-app-text(:to="{name: 'products_collection', params: {collection: cat.base_shopify_collection.post_name}}", :class="{'text-app-accent': $route.params.collection === cat.base_shopify_collection.post_name}")
              | {{cat.base_shopify_collection.post_title}}

      //- (makers dropdown, mobile)
      dropdown
        h6(slot="title") Makers
        ul.mt-18.-pb-18
          li.border-t.pl-30(v-for="mkr in makersLinks")
            router-link.block.pl-30.py-18.hover-text-app-text(:to="{name: 'products_collection', params: {collection: mkr.link.post_name}}", :class="{'text-app-accent': $route.params.collection === mkr.link.post_name}")
              | {{mkr.link.post_title}}

    //- (2. FILTERING ON COLLECTION) ===============================

    transition(name="filters-off" mode="out-in")
      .px-10.md-px-0(v-if="$route.name === 'products_collection'", :key="`${$route.name}__${$route.params.collection}`")
        //- heading
        h5.my-36.md-hidden.text-18.text-center
          | Refine #[i.capitalize {{ $route.params.collection.replaceAll('-', ' ') }}]

        //- sub-categories
        dropdown(v-if="subcategories.length > 1")
          h6(slot="title") Categories
          ul.pl-40.md-pl-0.pb-12
            li.my-18.md-mt-15.md-mb-0(v-for="sub in subcategories")
              product-filter.capitalize(:rt="filterRt({tag: sub })", :active="isActive('tag', sub)", :class="{'hidden': isDisabled('tags', sub)}") {{sub}}

        //- makers
        dropdown(v-if="makersFilters.length > 1")
          h6(slot="title") Makers
          ul.pl-40.md-pl-0.pb-12
            li.my-18.md-mt-15.md-mb-0(v-for="(maker, i) in makersFilters", :class="{'md-hidden': makersLimitActive && i > makersLimit}")
              product-filter(:rt="filterRt({ maker: maker })", :active="isActive('maker', maker)", :disabled="isDisabled('vendor', maker)") {{ maker }}
            button.pt-15.text-13.hidden.md-block.hover-text-app-text(@click="makersLimitActive = !makersLimitActive", v-show=' makersFilters.length > makersLimit')
              | Show {{makersLimitActive ? 'more +' : 'less –' }}

        //- genders
        dropdown(v-if="genders.length > 1")
          h6(slot="title") Gender
          ul.pl-40.md-pl-0.capitalize.pb-12
            li.my-18.md-mt-15.md-mb-0(v-for="gender in genders")
              product-filter(:rt="filterRt({ gender: tg(gender) })", :active="isActive('gender', tg(gender))", :disabled="isDisabled('tags', gender)") {{ tg(gender) }}

        //- sizes
        dropdown.w-full.overflow-x-hidden(v-if="sizes.length > 1")
          h6(slot="title") Size
          //- grid of buttons...
          ul.mt-18.flex.flex-wrap.w-grid-20.-ml-20.px-20.md-px-10.uppercase.pb-12.md-w-auto.md-mx-0.md-px-5.md-pb-0
            li.px-8.mb-10.w-1x3.md-px-5(v-for="size in sizes")
              router-link.block(:to="filterRt({ size: tg(size) })")
                btn.w-full(type="slim", :active="isActive('size', tg(size))", :disabled="isDisabled('tags', size)")
                  | {{ tg(size) }}

        //- colors
        dropdown(v-if="colors.length > 1")
          h6(slot="title") Colour
          ul.pl-40.md-pl-0.capitalize.text-15.md-text-13.pb-12
            li.my-18.md-mt-15.md-mb-0(v-for="color in colors")
              router-link.flex.items-center.hover-text-app-text(:to="filterRt({ color: tg(color) })", :class="{'text-app-accent': isActive('colour', tg(color))}")
                color-swatch.mr-8(:name="color", :active="isActive('colour', tg(color))")
                | {{ tg(color) }}
              //- product-filter(:rt="filterRt({ color: tg(color) })", :active="isActive('colour', tg(color))", :disabled="isDisabled('tags', color)") {{ tg(color) }}

        //- (btns: clear,apply | close)
        .flex.sticky.bottom-0.left-0.w-full.bg-gray-100.border-t.py-30.items-center.px-5.md-static.md-p-0.md-mt-30.md-border-t-0(v-if="filtersActive")
          //- template(v-if="filtersActive")
          button.flex-1.mx-5.md-mx-0.btn-theme-outlined(@click="clear")
            btn(type="filter-reset", theme="inherit") Clear
          button.flex-1.mx-5.md-hidden.btn-theme-black(@click="$emit('apply')")
            btn(type="filter-reset", theme="inherit") Apply
          //- template(v-else)
            btn.w-full.mx-5.md-hidden(type="filter-reset", @click="$emit('close')") Close
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import get from 'lodash/get'
import kb from 'lodash/kebabCase'
import toggleQueryParam from '@/plugins/toggleQueryParam'
import ProductFilter from './ProductFilter'
import IconChevron from '@/components/Icons/ChevronY'
import ColorSwatch from './ColorSwatch'
const tg = str => str.split(':')[1]
export default {
  name: 'ProductFiltersMenu',
  props: {
    products: { type: Array, default: () => ([]) },
    filtersActive: { type: String, default: undefined }
  },
  data () {
    return {
      makersLimit: 6,
      makersLimitActive: true
    }
  },
  computed: {
    ...mapState({
      categories: state => state.site ? state.site.categories_menu : [],
      makersLinks: state => state.site ? state.site.makers_links : []
    }),
    ...mapGetters(['winIs']),
    allTags () {
      // collect all tags from products
      let tags = this.products.reduce((acc, cur) => acc.concat(cur.tags), [])
      // format lowercase, for de-dupe
      tags = tags.map(tag => tag.toLowerCase())
      // de-dupe and sort
      tags = [...new Set(tags)].sort()
      return tags
    },
    subcategories () {
      const ignore = ['recommended']
      // tags which are: unprefixed, not-ignored, and doesn't match any active collection page
      return this.allTags.filter(tag => !tag.includes(':') && !ignore.includes(tag) && kb(tag) !== this.$route.params.collection)
    },
    makersFilters () {
      let vendors = this.products.map(p => p.vendor)
      vendors = [...new Set(vendors)] // de-dedupe
      return vendors
      // sort by enabled/disabled (based on active tags)
      // const val = m => this.isDisabled('vendor', m) ? 1 : 0
      // return vendors.sort((a, b) => val(a) - val(b)).filter(m => !this.isDisabled('vendor', m))
    },
    genders () {
      const order = ['gender:womens', 'gender:mens', 'gender:unisex']
      return this.allTags.filter(tag => tag.startsWith('gender:')).sort((a, b) => order.indexOf(a) - order.indexOf(b))
    },
    sizes () {
      // collect "size:..." tags
      let sizes = this.allTags.filter(tag => tag.startsWith('size:'))
      // sort based on defined order
      const order = ['os', 'xxxs', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl']
      const sz = tg => tg.toLowerCase().split(':')[1]
      sizes = sizes.sort((a, b) => order.indexOf(sz(a)) - order.indexOf(sz(b)))
      return sizes
    },
    colors () {
      return this.allTags.filter(tag => tag.startsWith('colour:'))
    }
  },
  methods: {
    tg,
    filterRt ({ tag, maker, gender, size, color }) {
      const rt = this.$route.query
      tag = toggleQueryParam(rt.tag, kb(tag))
      maker = toggleQueryParam(rt.maker, kb(maker))
      gender = toggleQueryParam(rt.gender, kb(gender))
      size = toggleQueryParam(rt.size, kb(size))
      color = toggleQueryParam(rt.colour, kb(color))
      const qry = {
        tag: tag, // || rt.type,
        maker: maker, // || rt.maker,
        gender: gender, // || rt.gender,
        size: size, // || rt.size,
        colour: color,
        sort: rt.sort
      }
      Object.keys(qry).forEach(key => { if (!qry[key]) delete qry[key] })
      return { query: qry }
    },
    isActive (param, val, prefix = '') {
      param = this.$route.query[param]
      return (param && param.split(',').includes(kb(val))) || kb(val) === this.$route.params.collection
    },
    isDisabled (path, val = '') {
      if (!this.products || !this.products.length || !this.$route.params.collection) return false
      // search tags
      if (path === 'tags') {
        // compare via kebabCase result
        return !this.products.filter(prd => {
          return prd.tags && prd.tags.map(tag => kb(tag)).includes(kb(val))
        }).length
      }
      return !this.products.filter(prd => get(prd, path) === val).length
    },
    clear () {
      this.$emit('clear')
      return this.$router.push({ query: {} })
    },
    listActive (arr, key) {
      return arr && arr.length // && arr.filter(fltr => !this.isDisabled(key, fltr)).length > 1
    },
    closePrimaryDropdowns () {
      if (this.$refs.primary) {
        Array.from(this.$refs.primary.querySelectorAll('details[open]')).forEach(el => el.removeAttribute('open'))
      }
    }
  },
  components: { ProductFilter, IconChevron, ColorSwatch }
}

</script>

<style>
.product-filters-menu {
  & details > summary {
    list-style: none;
  }
  & details > summary::-webkit-details-marker {
    display: none;
  }
}
.filters-enter-active,.filters-leave-active{ transition: opacity 400ms; }
.filters-enter, .filters-leave-to{opacity:0;}
</style>
